import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={`${styles.inner} container-wide`}>
        <div className={styles.colophon}>
          <p className={styles.heading}>ViBE</p>
          <p className={styles.expansion}>
            <span className={styles.exp}>V</span>ernacular{' '}
            <span className={styles.exp}>I</span>nternet{' '}
            <span className={styles.exp}>B</span>ehavioral{' '}
            <span className={styles.exp}>E</span>valuation
          </p>
          <p className={styles.body}>
            A one-week Twitter benchmark for frontier model families. Drawn from public discussion
            on Twitter, labelled by an independent judge model, aggregated by bootstrap.
          </p>
        </div>

        <nav className={styles.linkList} aria-label="Site">
          <p className={styles.eyebrow}>Site</p>
          <Link to="/" className={styles.link}>Leaderboard</Link>
          <Link to="/methodology" className={styles.link}>Methodology</Link>
          <Link to="/paper" className={styles.link}>Paper</Link>
        </nav>

        <nav className={styles.linkList} aria-label="Data">
          <p className={styles.eyebrow}>Data</p>
          <a className={styles.linkMono} href="/data/leaderboard.json">leaderboard.json</a>
          <a className={styles.linkMono} href="/data/meta.json">meta.json</a>
          <a className={styles.linkMono} href="/data/paper/latest.json">paper/latest.json</a>
        </nav>
      </div>

      <div className={`${styles.legal} container-wide`}>
        <p className={styles.legalLine}>
          Reception is not capability. Capability is not reception. The difference is the entire point.
        </p>
        <p className={styles.credit}>
          With lols, by{' '}
          <a
            href="https://x.com/deeflectcom"
            target="_blank"
            rel="noreferrer noopener"
            className={styles.creditLink}
          >
            @deeflect
          </a>
          .
        </p>
      </div>
    </footer>
  );
}
